module.exports = __webpack_public_path__ + "lato-bold-cccb897485813c7c256901dbca54ecf2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-bold/lato-bold.woff2
// module id = 1058
// module chunks = 0